var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.score === 1)?_c('review-button-1'):(_vm.score === 2)?_c('review-button-2'):(_vm.score === 3)?_c('review-button-3'):(_vm.score === 4)?_c('review-button-4'):(_vm.score === 5)?_c('review-button-5'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }